export enum JobStatus {
  Draft = "draft",
  Open = "open",
  Processing = "processing",
  Completed = "completed",
}
